var _Defs, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, G, Rect, Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgBinocularsSquare(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "binocularsSquare_svg__Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)), _G || (_G = /*#__PURE__*/React.createElement(G, {
    id: "binocularsSquare_svg__Racecard_-_Tips_Tab_Default_",
    "data-name": "Racecard - Tips Tab (Default)"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 15,
    height: 15,
    rx: 3,
    ry: 3,
    fill: "#1d1c39"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "binocularsSquare_svg__cls-1",
    d: "M3.41 9.52c-.11 0-.21-.09-.21-.21 0-.78.63-1.41 1.41-1.41.11 0 .21.09.21.21s-.09.21-.21.21c-.55 0-1 .45-1 1 0 .11-.09.21-.21.21zM9.63 9.52c-.11 0-.21-.09-.21-.21 0-.78.63-1.41 1.41-1.41.11 0 .21.09.21.21s-.09.21-.21.21c-.55 0-1 .45-1 1 0 .11-.09.21-.21.21z"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "binocularsSquare_svg__cls-1",
    d: "M13.12 8.27a2.91 2.91 0 00-.35-.62l-1.05-1.88a2.093 2.093 0 00-1-1.03c-.08-.63-.62-1.11-1.27-1.11-.71 0-1.28.57-1.28 1.28 0 .16.03.31.08.45-.13.17-.23.37-.3.58-.11-.03-.24-.05-.36-.05-.11 0-.21.01-.31.04-.08-.23-.19-.44-.34-.62a1.276 1.276 0 00-1.22-1.67c-.66 0-1.21.5-1.28 1.15-.26.13-.49.32-.67.55-.12.16-.23.33-.3.52L2.45 7.65c-.14.18-.25.38-.34.59-.12.3-.19.64-.19.99 0 1.45 1.17 2.62 2.62 2.62a2.6 2.6 0 002.49-1.82c.17.11.37.17.59.17s.42-.06.59-.17a2.616 2.616 0 104.93-1.75zM4.5 11.12a1.9 1.9 0 110-3.8 1.9 1.9 0 110 3.8zm3.1-1.57c-.24 0-.43-.19-.43-.43s.19-.43.43-.43.43.19.43.43-.19.43-.43.43zm3.08 1.57a1.9 1.9 0 110-3.8 1.9 1.9 0 110 3.8z"
  }))));
}
export default SvgBinocularsSquare;